import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_wildsky_common_proto from './dcei_wildsky_common_proto';
class Mail_MailAttachments {
  get descriptor() {
    return Mail_MailAttachments.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._rewardItems = [];
  }
  isEmpty() {
    if (this._rewardItems.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Mail_MailAttachments) {
      return value;
    }
    return Mail_MailAttachments.fromJson(value);
  }
  static fromJson(json) {
    const result = new Mail_MailAttachments();
    result._rewardItems = JsonToList(json.rewardItems, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._rewardItems.length > 0) {
      result.rewardItems = ArrayToJson(this._rewardItems, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    }
    return result;
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair[]}
   */
  get rewardItems() {
    return this._rewardItems;
  }
  addRewardItems(path, value) {
    return {type: 'ADD', path: path.concat(['rewardItems']), value: value.toJson()};
  }
  setRewardItems(path, value) {
    return {type: 'SET', path: path.concat(['rewardItems']), value: ArrayToJson(value, dcei_wildsky_common_proto.InventoryItemKeyValuePair)};
  }
  setRewardItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['rewardItems', key]), value: value.toJson()};
  }
  deleteRewardItems(path) {
    return {type: 'DELETE', path: path.concat(['rewardItems'])};
  }
  deleteRewardItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['rewardItems', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "rewardItems": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Mail_MailAttachments(this);
              copy._rewardItems = [];        for (let i of value) {
                copy._rewardItems.push(dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Mail_MailAttachments(this);
              copy._rewardItems = copy._rewardItems.concat([dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._rewardItems.length === 0) {
                return this;
              }
              const copy = new Mail_MailAttachments(this);
              copy._rewardItems = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._rewardItems.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Mail_MailAttachments(this);
              copy._rewardItems = copy._rewardItems.slice();
              copy._rewardItems[path[1]] = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Mail_MailAttachments(this);
              copy._rewardItems = copy._rewardItems.slice(0, path[1]).concat(copy._rewardItems.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._rewardItems.length) {
            return this;
          }
          const oldValue = this._rewardItems[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Mail_MailAttachments(this);
          copy._rewardItems = copy._rewardItems.slice();
          copy._rewardItems[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Mail_MailAttachments} other
   * @returns {Mail_MailAttachments}
   */
  merge(other) {
    const copy = new Mail_MailAttachments(this);
    copy._rewardItems = this._rewardItems.concat(other._rewardItems);
    return copy;
  }
}
Mail_MailAttachments.default = new Mail_MailAttachments();
class Mail_MailAttachments_Builder {
  constructor(value) {
    this._value = new Mail_MailAttachments(value);
  }
  build() {
    return new Mail_MailAttachments(this._value);
  }
  addAllRewardItems(values) {
    this._value._rewardItems = this._value._rewardItems.concat(values);
    return this;
  }
  addRewardItems(value) {
    this._value._rewardItems = this._value._rewardItems.concat([value]);
    return this;
  }
  setRewardItems(index, value) {
    this._value._rewardItems = this._value._rewardItems.concat();
    this._value._rewardItems[index] = value;
    return this;
  }
  clearRewardItems() {
    this._value._rewardItems = [];
    return this;
  }
}
Mail_MailAttachments.Builder = Mail_MailAttachments_Builder;
class Mail_MailAttachments_WithParent {
  /**
   * @param {Mail_MailAttachments} value
   * @param {Mail_MailAttachments_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Mail_MailAttachments.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfRewardItems() {
    if (!this._selfRewardItems) {
      this._selfRewardItems = [];
      for (let i of this._value.rewardItems) {
        this._selfRewardItems.push(new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(i, null));
      }
    }
    return this._selfRewardItems;
  }
  get inherentRewardItems() {
    if (!this._inherentRewardItems) {
      this._inherentRewardItems = this._parent ? this._parent.rewardItems : [];
    }
    return this._inherentRewardItems;
  }
  get rewardItems() {
    if (!this._allRewardItems) {
      this._allRewardItems = this._parent ? this._parent.rewardItems.concat(this.selfRewardItems) : this.selfRewardItems;
    }
    return this._allRewardItems;
  }
  update(current, parent) {
    const result = new Mail_MailAttachments_WithParent(current, parent);
    if (this._selfRewardItems) {
      if (this._value.rewardItems === current.rewardItems) {
        result._selfRewardItems = this._selfRewardItems;
      } else {
        result._selfRewardItems = [];
        for (let i = 0; i < current.rewardItems.length; i++) {
          const oldValue = this._value.rewardItems[i];
          if (oldValue) {
            const oldCache = this._selfRewardItems[i];
            if (oldValue === current.rewardItems[i]) {
              result._selfRewardItems[i] = oldCache;
            } else {
              result._selfRewardItems[i] = oldCache.update(current.rewardItems[i], null);
            }
          } else {
            result._selfRewardItems[i] = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(current.rewardItems[i], null);
          }
        }
      }
    }
    return result;
  }
}
Mail_MailAttachments_WithParent.default = new Mail_MailAttachments_WithParent(Mail_MailAttachments.default, null);
Mail_MailAttachments.WithParent = Mail_MailAttachments_WithParent;
class Mail_MailAttachments_Descriptor {
  get rewardItems() {
    if (!this._rewardItems) {
      this._rewardItems = {
        name: "rewardItems",
        Name: "RewardItems",
        number: 1,
        protoType: 11,
        protoName: "reward_items",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewardItems;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.rewardItems,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
Mail_MailAttachments.descriptor = new Mail_MailAttachments_Descriptor();
export class Mail {
  get descriptor() {
    return Mail.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasInstanceId = false;
    this._instanceId = null;
    this._hasTitle = false;
    this._title = null;
    this._hasContent = false;
    this._content = null;
    this._hasAttachments = false;
    this._attachments = null;
    this._hasTime = false;
    this._time = null;
    this._hasKey = false;
    this._key = null;
    this._hasIsGlobal = false;
    this._isGlobal = null;
    this._hasEntry = false;
    this._entry = null;
  }
  isEmpty() {
    if (this._hasInstanceId) return false;
    if (this._hasTitle) return false;
    if (this._hasContent) return false;
    if (this._hasAttachments && !this._attachments.isEmpty()) return false;
    if (this._hasTime) return false;
    if (this._hasKey) return false;
    if (this._hasIsGlobal) return false;
    if (this._hasEntry && !this._entry.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Mail) {
      return value;
    }
    return Mail.fromJson(value);
  }
  static fromJson(json) {
    const result = new Mail();
    if (json.instanceId != null) {
      result._hasInstanceId = true;
      result._instanceId = JsonToInt32.fromJson(json.instanceId);
    }
    if (json.title != null) {
      result._hasTitle = true;
      result._title = JsonToString.fromJson(json.title);
    }
    if (json.content != null) {
      result._hasContent = true;
      result._content = JsonToString.fromJson(json.content);
    }
    if (json.attachments != null) {
      result._hasAttachments = true;
      result._attachments = Mail_MailAttachments.fromJson(json.attachments);
    }
    if (json.time != null) {
      result._hasTime = true;
      result._time = JsonToInt64.fromJson(json.time);
    }
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.isGlobal != null) {
      result._hasIsGlobal = true;
      result._isGlobal = JsonToBoolean.fromJson(json.isGlobal);
    }
    if (json.entry != null) {
      result._hasEntry = true;
      result._entry = dcei_wildsky_common_proto.PageNavigationEntry.fromJson(json.entry);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasInstanceId) {
      result.instanceId = JsonToInt32.toJson(this._instanceId);
    }
    if (this._hasTitle) {
      result.title = JsonToString.toJson(this._title);
    }
    if (this._hasContent) {
      result.content = JsonToString.toJson(this._content);
    }
    if (this._hasAttachments && !this._attachments.isEmpty()) {
      result.attachments = Mail_MailAttachments.toJson(this._attachments);
    }
    if (this._hasTime) {
      result.time = JsonToInt64.toJson(this._time);
    }
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasIsGlobal) {
      result.isGlobal = JsonToBoolean.toJson(this._isGlobal);
    }
    if (this._hasEntry && !this._entry.isEmpty()) {
      result.entry = dcei_wildsky_common_proto.PageNavigationEntry.toJson(this._entry);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get instanceId() {
    return this._hasInstanceId ? this._instanceId : JsonToInt32.default;
  }
  get hasInstanceId() {
    return this._hasInstanceId;
  }
  setInstanceId(path, value) {
    return {type: 'SET', path: path.concat(['instanceId']), value};
  }
  deleteInstanceId(path) {
    return {type: 'DELETE', path: path.concat(['instanceId'])};
  }
  /**
   * @returns {string}
   */
  get title() {
    return this._hasTitle ? this._title : JsonToString.default;
  }
  get hasTitle() {
    return this._hasTitle;
  }
  setTitle(path, value) {
    return {type: 'SET', path: path.concat(['title']), value};
  }
  deleteTitle(path) {
    return {type: 'DELETE', path: path.concat(['title'])};
  }
  /**
   * @returns {string}
   */
  get content() {
    return this._hasContent ? this._content : JsonToString.default;
  }
  get hasContent() {
    return this._hasContent;
  }
  setContent(path, value) {
    return {type: 'SET', path: path.concat(['content']), value};
  }
  deleteContent(path) {
    return {type: 'DELETE', path: path.concat(['content'])};
  }
  /**
   * @returns {Mail_MailAttachments}
   */
  get attachments() {
    return this._hasAttachments ? this._attachments : Mail_MailAttachments.default;
  }
  get hasAttachments() {
    return this._hasAttachments;
  }
  setAttachments(path, value) {
    return {type: 'SET', path: path.concat(['attachments']), value: value.toJson()};
  }
  deleteAttachments(path) {
    return {type: 'DELETE', path: path.concat(['attachments'])};
  }
  /**
   * @returns {string}
   */
  get time() {
    return this._hasTime ? this._time : JsonToInt64.default;
  }
  get hasTime() {
    return this._hasTime;
  }
  setTime(path, value) {
    return {type: 'SET', path: path.concat(['time']), value};
  }
  deleteTime(path) {
    return {type: 'DELETE', path: path.concat(['time'])};
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {boolean}
   */
  get isGlobal() {
    return this._hasIsGlobal ? this._isGlobal : JsonToBoolean.default;
  }
  get hasIsGlobal() {
    return this._hasIsGlobal;
  }
  setIsGlobal(path, value) {
    return {type: 'SET', path: path.concat(['isGlobal']), value};
  }
  deleteIsGlobal(path) {
    return {type: 'DELETE', path: path.concat(['isGlobal'])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.PageNavigationEntry}
   */
  get entry() {
    return this._hasEntry ? this._entry : dcei_wildsky_common_proto.PageNavigationEntry.default;
  }
  get hasEntry() {
    return this._hasEntry;
  }
  setEntry(path, value) {
    return {type: 'SET', path: path.concat(['entry']), value: value.toJson()};
  }
  deleteEntry(path) {
    return {type: 'DELETE', path: path.concat(['entry'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "instanceId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Mail(this);
              copy._hasInstanceId = true;
              copy._instanceId = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasInstanceId) {
                return this;
              }
              const copy = new Mail(this);
              copy._hasInstanceId = false;
              copy._instanceId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "title": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Mail(this);
              copy._hasTitle = true;
              copy._title = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTitle) {
                return this;
              }
              const copy = new Mail(this);
              copy._hasTitle = false;
              copy._title = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "content": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Mail(this);
              copy._hasContent = true;
              copy._content = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasContent) {
                return this;
              }
              const copy = new Mail(this);
              copy._hasContent = false;
              copy._content = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "attachments": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Mail(this);
              copy._hasAttachments = true;
              copy._attachments = Mail_MailAttachments.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAttachments) {
                return this;
              }
              const copy = new Mail(this);
              copy._hasAttachments = false;
              copy._attachments = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasAttachments) {
            const copy = new Mail(this);
            copy._hasAttachments = true;
            copy._attachments = Mail_MailAttachments.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._attachments.apply(type, path.slice(1), value);
          if (newValue === this._attachments) {
            return this;
          }
          const copy = new Mail(this);
          copy._attachments = copy._attachments.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "time": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Mail(this);
              copy._hasTime = true;
              copy._time = JsonToInt64.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTime) {
                return this;
              }
              const copy = new Mail(this);
              copy._hasTime = false;
              copy._time = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Mail(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new Mail(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "isGlobal": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Mail(this);
              copy._hasIsGlobal = true;
              copy._isGlobal = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIsGlobal) {
                return this;
              }
              const copy = new Mail(this);
              copy._hasIsGlobal = false;
              copy._isGlobal = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "entry": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Mail(this);
              copy._hasEntry = true;
              copy._entry = dcei_wildsky_common_proto.PageNavigationEntry.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEntry) {
                return this;
              }
              const copy = new Mail(this);
              copy._hasEntry = false;
              copy._entry = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasEntry) {
            const copy = new Mail(this);
            copy._hasEntry = true;
            copy._entry = dcei_wildsky_common_proto.PageNavigationEntry.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._entry.apply(type, path.slice(1), value);
          if (newValue === this._entry) {
            return this;
          }
          const copy = new Mail(this);
          copy._entry = copy._entry.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Mail} other
   * @returns {Mail}
   */
  merge(other) {
    const copy = new Mail(this);
    if (other._hasInstanceId) {
      copy._hasInstanceId = true;
      copy._instanceId = other._instanceId;
    }
    if (other._hasTitle) {
      copy._hasTitle = true;
      copy._title = other._title;
    }
    if (other._hasContent) {
      copy._hasContent = true;
      copy._content = other._content;
    }
    if (other._hasAttachments) {
      if (copy._hasAttachments) {
        copy._attachments = copy.attachments.merge(other.attachments);
      } else {
        copy._attachments = other._attachments;
      }
      copy._hasAttachments = true;
    }
    if (other._hasTime) {
      copy._hasTime = true;
      copy._time = other._time;
    }
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasIsGlobal) {
      copy._hasIsGlobal = true;
      copy._isGlobal = other._isGlobal;
    }
    if (other._hasEntry) {
      if (copy._hasEntry) {
        copy._entry = copy.entry.merge(other.entry);
      } else {
        copy._entry = other._entry;
      }
      copy._hasEntry = true;
    }
    return copy;
  }
}
Mail.default = new Mail();
Mail.MailAttachments = Mail_MailAttachments;
class Mail_Builder {
  constructor(value) {
    this._value = new Mail(value);
  }
  build() {
    return new Mail(this._value);
  }
  setInstanceId(value) {
    this._value._hasInstanceId = true;
    this._value._instanceId = value;
    return this;
  }
  deleteInstanceId() {
    this._value._hasInstanceId = false;
    this._value._instanceId = null;
    return this;
  }
  setTitle(value) {
    this._value._hasTitle = true;
    this._value._title = value;
    return this;
  }
  deleteTitle() {
    this._value._hasTitle = false;
    this._value._title = null;
    return this;
  }
  setContent(value) {
    this._value._hasContent = true;
    this._value._content = value;
    return this;
  }
  deleteContent() {
    this._value._hasContent = false;
    this._value._content = null;
    return this;
  }
  setAttachments(value) {
    this._value._hasAttachments = true;
    this._value._attachments = value;
    return this;
  }
  deleteAttachments() {
    this._value._hasAttachments = false;
    this._value._attachments = null;
    return this;
  }
  setTime(value) {
    this._value._hasTime = true;
    this._value._time = value;
    return this;
  }
  deleteTime() {
    this._value._hasTime = false;
    this._value._time = null;
    return this;
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setIsGlobal(value) {
    this._value._hasIsGlobal = true;
    this._value._isGlobal = value;
    return this;
  }
  deleteIsGlobal() {
    this._value._hasIsGlobal = false;
    this._value._isGlobal = null;
    return this;
  }
  setEntry(value) {
    this._value._hasEntry = true;
    this._value._entry = value;
    return this;
  }
  deleteEntry() {
    this._value._hasEntry = false;
    this._value._entry = null;
    return this;
  }
}
Mail.Builder = Mail_Builder;
class Mail_WithParent {
  /**
   * @param {Mail} value
   * @param {Mail_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Mail.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasInstanceId() {
    if (this._cachedHasInstanceId === undefined) {
      if (this._value.hasInstanceId) {
        this._cachedHasInstanceId = true;
      } else {
        this._cachedHasInstanceId = this._parent ? this._parent.hasInstanceId : false;
      }
    }
    return this._cachedHasInstanceId;
  }
  get instanceId() {
    if (this._cachedInstanceId === undefined) {
      if (this._value.hasInstanceId) {
        this._cachedInstanceId = this._value.instanceId;
      } else {
        this._cachedInstanceId = this._parent ? this._parent.instanceId : this._value.instanceId;
      }
    }
    return this._cachedInstanceId;
  }
  get hasTitle() {
    if (this._cachedHasTitle === undefined) {
      if (this._value.hasTitle) {
        this._cachedHasTitle = true;
      } else {
        this._cachedHasTitle = this._parent ? this._parent.hasTitle : false;
      }
    }
    return this._cachedHasTitle;
  }
  get title() {
    if (this._cachedTitle === undefined) {
      if (this._value.hasTitle) {
        this._cachedTitle = this._value.title;
      } else {
        this._cachedTitle = this._parent ? this._parent.title : this._value.title;
      }
    }
    return this._cachedTitle;
  }
  get hasContent() {
    if (this._cachedHasContent === undefined) {
      if (this._value.hasContent) {
        this._cachedHasContent = true;
      } else {
        this._cachedHasContent = this._parent ? this._parent.hasContent : false;
      }
    }
    return this._cachedHasContent;
  }
  get content() {
    if (this._cachedContent === undefined) {
      if (this._value.hasContent) {
        this._cachedContent = this._value.content;
      } else {
        this._cachedContent = this._parent ? this._parent.content : this._value.content;
      }
    }
    return this._cachedContent;
  }
  get hasAttachments() {
    if (this._cachedHasAttachments === undefined) {
      if (this._value.hasAttachments) {
        this._cachedHasAttachments = true;
      } else {
        this._cachedHasAttachments = this._parent ? this._parent.hasAttachments : false;
      }
    }
    return this._cachedHasAttachments;
  }
  get attachments() {
    if (!this._cachedAttachments) {
      if (this._value.hasAttachments) {
        this._cachedAttachments = new Mail_MailAttachments.WithParent(this._value.attachments, this._parent && this._parent.hasAttachments ? this._parent.attachments : null);
      } else {
        this._cachedAttachments = this._parent ? new Mail_MailAttachments.WithParent(Mail_MailAttachments.default, this._parent.attachments) : Mail_MailAttachments.WithParent.default;
      }
    }
    return this._cachedAttachments;
  }
  get hasTime() {
    if (this._cachedHasTime === undefined) {
      if (this._value.hasTime) {
        this._cachedHasTime = true;
      } else {
        this._cachedHasTime = this._parent ? this._parent.hasTime : false;
      }
    }
    return this._cachedHasTime;
  }
  get time() {
    if (this._cachedTime === undefined) {
      if (this._value.hasTime) {
        this._cachedTime = this._value.time;
      } else {
        this._cachedTime = this._parent ? this._parent.time : this._value.time;
      }
    }
    return this._cachedTime;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasIsGlobal() {
    if (this._cachedHasIsGlobal === undefined) {
      if (this._value.hasIsGlobal) {
        this._cachedHasIsGlobal = true;
      } else {
        this._cachedHasIsGlobal = this._parent ? this._parent.hasIsGlobal : false;
      }
    }
    return this._cachedHasIsGlobal;
  }
  get isGlobal() {
    if (this._cachedIsGlobal === undefined) {
      if (this._value.hasIsGlobal) {
        this._cachedIsGlobal = this._value.isGlobal;
      } else {
        this._cachedIsGlobal = this._parent ? this._parent.isGlobal : this._value.isGlobal;
      }
    }
    return this._cachedIsGlobal;
  }
  get hasEntry() {
    if (this._cachedHasEntry === undefined) {
      if (this._value.hasEntry) {
        this._cachedHasEntry = true;
      } else {
        this._cachedHasEntry = this._parent ? this._parent.hasEntry : false;
      }
    }
    return this._cachedHasEntry;
  }
  get entry() {
    if (!this._cachedEntry) {
      if (this._value.hasEntry) {
        this._cachedEntry = new dcei_wildsky_common_proto.PageNavigationEntry.WithParent(this._value.entry, this._parent && this._parent.hasEntry ? this._parent.entry : null);
      } else {
        this._cachedEntry = this._parent ? new dcei_wildsky_common_proto.PageNavigationEntry.WithParent(dcei_wildsky_common_proto.PageNavigationEntry.default, this._parent.entry) : dcei_wildsky_common_proto.PageNavigationEntry.WithParent.default;
      }
    }
    return this._cachedEntry;
  }
  update(current, parent) {
    const result = new Mail_WithParent(current, parent);
    if (this._cachedAttachments && this._value.hasAttachments && current.hasAttachments) {
      if (this._value.attachments === current.attachments && this._parent === parent) {
        result._cachedAttachments = this._cachedAttachments;
      } else {
        result._cachedAttachments = this._cachedAttachments.update(current.attachments, parent && parent.hasAttachments ? parent.attachments : null);
      }
    }
    if (this._cachedEntry && this._value.hasEntry && current.hasEntry) {
      if (this._value.entry === current.entry && this._parent === parent) {
        result._cachedEntry = this._cachedEntry;
      } else {
        result._cachedEntry = this._cachedEntry.update(current.entry, parent && parent.hasEntry ? parent.entry : null);
      }
    }
    return result;
  }
}
Mail_WithParent.default = new Mail_WithParent(Mail.default, null);
Mail.WithParent = Mail_WithParent;
class Mail_Descriptor {
  get instanceId() {
    if (!this._instanceId) {
      this._instanceId = {
        name: "instanceId",
        Name: "InstanceId",
        number: 1,
        protoType: 5,
        protoName: "instance_id",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._instanceId;
  }
  get title() {
    if (!this._title) {
      this._title = {
        name: "title",
        Name: "Title",
        number: 2,
        protoType: 9,
        protoName: "title",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._title;
  }
  get content() {
    if (!this._content) {
      this._content = {
        name: "content",
        Name: "Content",
        number: 3,
        protoType: 9,
        protoName: "content",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._content;
  }
  get attachments() {
    if (!this._attachments) {
      this._attachments = {
        name: "attachments",
        Name: "Attachments",
        number: 4,
        protoType: 11,
        protoName: "attachments",
        type: Mail_MailAttachments,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._attachments;
  }
  get time() {
    if (!this._time) {
      this._time = {
        name: "time",
        Name: "Time",
        number: 5,
        protoType: 3,
        protoName: "time",
        type: JsonToInt64,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._time;
  }
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 6,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get isGlobal() {
    if (!this._isGlobal) {
      this._isGlobal = {
        name: "isGlobal",
        Name: "IsGlobal",
        number: 7,
        protoType: 8,
        protoName: "is_global",
        type: JsonToBoolean,
        options: {
          comments: "Providing a field for lua to set, it will be set at client side depending on if this mail is fetched from master/global server",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._isGlobal;
  }
  get entry() {
    if (!this._entry) {
      this._entry = {
        name: "entry",
        Name: "Entry",
        number: 8,
        protoType: 11,
        protoName: "entry",
        type: dcei_wildsky_common_proto.PageNavigationEntry,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._entry;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.instanceId,
        this.title,
        this.content,
        this.attachments,
        this.time,
        this.key,
        this.isGlobal,
        this.entry,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForInstanceId",
        Name: "DummyOneofForInstanceId",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTitle",
        Name: "DummyOneofForTitle",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForContent",
        Name: "DummyOneofForContent",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAttachments",
        Name: "DummyOneofForAttachments",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTime",
        Name: "DummyOneofForTime",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIsGlobal",
        Name: "DummyOneofForIsGlobal",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEntry",
        Name: "DummyOneofForEntry",
        fields: [
          this.fields[7],
        ],
      });
    }
    return this._oneofs;
  }
}
Mail.descriptor = new Mail_Descriptor();
class MailDefinition_MailContent {
  get descriptor() {
    return MailDefinition_MailContent.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasLanguage = false;
    this._language = null;
    this._hasTitle = false;
    this._title = null;
    this._hasContent = false;
    this._content = null;
  }
  isEmpty() {
    if (this._hasLanguage) return false;
    if (this._hasTitle) return false;
    if (this._hasContent) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MailDefinition_MailContent) {
      return value;
    }
    return MailDefinition_MailContent.fromJson(value);
  }
  static fromJson(json) {
    const result = new MailDefinition_MailContent();
    if (json.language != null) {
      result._hasLanguage = true;
      result._language = JsonToString.fromJson(json.language);
    }
    if (json.title != null) {
      result._hasTitle = true;
      result._title = JsonToString.fromJson(json.title);
    }
    if (json.content != null) {
      result._hasContent = true;
      result._content = JsonToString.fromJson(json.content);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasLanguage) {
      result.language = JsonToString.toJson(this._language);
    }
    if (this._hasTitle) {
      result.title = JsonToString.toJson(this._title);
    }
    if (this._hasContent) {
      result.content = JsonToString.toJson(this._content);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get language() {
    return this._hasLanguage ? this._language : JsonToString.default;
  }
  get hasLanguage() {
    return this._hasLanguage;
  }
  setLanguage(path, value) {
    return {type: 'SET', path: path.concat(['language']), value};
  }
  deleteLanguage(path) {
    return {type: 'DELETE', path: path.concat(['language'])};
  }
  /**
   * @returns {string}
   */
  get title() {
    return this._hasTitle ? this._title : JsonToString.default;
  }
  get hasTitle() {
    return this._hasTitle;
  }
  setTitle(path, value) {
    return {type: 'SET', path: path.concat(['title']), value};
  }
  deleteTitle(path) {
    return {type: 'DELETE', path: path.concat(['title'])};
  }
  /**
   * @returns {string}
   */
  get content() {
    return this._hasContent ? this._content : JsonToString.default;
  }
  get hasContent() {
    return this._hasContent;
  }
  setContent(path, value) {
    return {type: 'SET', path: path.concat(['content']), value};
  }
  deleteContent(path) {
    return {type: 'DELETE', path: path.concat(['content'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "language": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MailDefinition_MailContent(this);
              copy._hasLanguage = true;
              copy._language = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLanguage) {
                return this;
              }
              const copy = new MailDefinition_MailContent(this);
              copy._hasLanguage = false;
              copy._language = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "title": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MailDefinition_MailContent(this);
              copy._hasTitle = true;
              copy._title = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTitle) {
                return this;
              }
              const copy = new MailDefinition_MailContent(this);
              copy._hasTitle = false;
              copy._title = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "content": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MailDefinition_MailContent(this);
              copy._hasContent = true;
              copy._content = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasContent) {
                return this;
              }
              const copy = new MailDefinition_MailContent(this);
              copy._hasContent = false;
              copy._content = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MailDefinition_MailContent} other
   * @returns {MailDefinition_MailContent}
   */
  merge(other) {
    const copy = new MailDefinition_MailContent(this);
    if (other._hasLanguage) {
      copy._hasLanguage = true;
      copy._language = other._language;
    }
    if (other._hasTitle) {
      copy._hasTitle = true;
      copy._title = other._title;
    }
    if (other._hasContent) {
      copy._hasContent = true;
      copy._content = other._content;
    }
    return copy;
  }
}
MailDefinition_MailContent.default = new MailDefinition_MailContent();
class MailDefinition_MailContent_Builder {
  constructor(value) {
    this._value = new MailDefinition_MailContent(value);
  }
  build() {
    return new MailDefinition_MailContent(this._value);
  }
  setLanguage(value) {
    this._value._hasLanguage = true;
    this._value._language = value;
    return this;
  }
  deleteLanguage() {
    this._value._hasLanguage = false;
    this._value._language = null;
    return this;
  }
  setTitle(value) {
    this._value._hasTitle = true;
    this._value._title = value;
    return this;
  }
  deleteTitle() {
    this._value._hasTitle = false;
    this._value._title = null;
    return this;
  }
  setContent(value) {
    this._value._hasContent = true;
    this._value._content = value;
    return this;
  }
  deleteContent() {
    this._value._hasContent = false;
    this._value._content = null;
    return this;
  }
}
MailDefinition_MailContent.Builder = MailDefinition_MailContent_Builder;
class MailDefinition_MailContent_WithParent {
  /**
   * @param {MailDefinition_MailContent} value
   * @param {MailDefinition_MailContent_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MailDefinition_MailContent.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasLanguage() {
    if (this._cachedHasLanguage === undefined) {
      if (this._value.hasLanguage) {
        this._cachedHasLanguage = true;
      } else {
        this._cachedHasLanguage = this._parent ? this._parent.hasLanguage : false;
      }
    }
    return this._cachedHasLanguage;
  }
  get language() {
    if (this._cachedLanguage === undefined) {
      if (this._value.hasLanguage) {
        this._cachedLanguage = this._value.language;
      } else {
        this._cachedLanguage = this._parent ? this._parent.language : this._value.language;
      }
    }
    return this._cachedLanguage;
  }
  get hasTitle() {
    if (this._cachedHasTitle === undefined) {
      if (this._value.hasTitle) {
        this._cachedHasTitle = true;
      } else {
        this._cachedHasTitle = this._parent ? this._parent.hasTitle : false;
      }
    }
    return this._cachedHasTitle;
  }
  get title() {
    if (this._cachedTitle === undefined) {
      if (this._value.hasTitle) {
        this._cachedTitle = this._value.title;
      } else {
        this._cachedTitle = this._parent ? this._parent.title : this._value.title;
      }
    }
    return this._cachedTitle;
  }
  get hasContent() {
    if (this._cachedHasContent === undefined) {
      if (this._value.hasContent) {
        this._cachedHasContent = true;
      } else {
        this._cachedHasContent = this._parent ? this._parent.hasContent : false;
      }
    }
    return this._cachedHasContent;
  }
  get content() {
    if (this._cachedContent === undefined) {
      if (this._value.hasContent) {
        this._cachedContent = this._value.content;
      } else {
        this._cachedContent = this._parent ? this._parent.content : this._value.content;
      }
    }
    return this._cachedContent;
  }
  update(current, parent) {
    const result = new MailDefinition_MailContent_WithParent(current, parent);
    return result;
  }
}
MailDefinition_MailContent_WithParent.default = new MailDefinition_MailContent_WithParent(MailDefinition_MailContent.default, null);
MailDefinition_MailContent.WithParent = MailDefinition_MailContent_WithParent;
class MailDefinition_MailContent_Descriptor {
  get language() {
    if (!this._language) {
      this._language = {
        name: "language",
        Name: "Language",
        number: 1,
        protoType: 9,
        protoName: "language",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedLanguageCodes",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._language;
  }
  get title() {
    if (!this._title) {
      this._title = {
        name: "title",
        Name: "Title",
        number: 2,
        protoType: 9,
        protoName: "title",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._title;
  }
  get content() {
    if (!this._content) {
      this._content = {
        name: "content",
        Name: "Content",
        number: 3,
        protoType: 9,
        protoName: "content",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._content;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.language,
        this.title,
        this.content,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForLanguage",
        Name: "DummyOneofForLanguage",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTitle",
        Name: "DummyOneofForTitle",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForContent",
        Name: "DummyOneofForContent",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
MailDefinition_MailContent.descriptor = new MailDefinition_MailContent_Descriptor();
class MailDefinition_MailGroup {
  get descriptor() {
    return MailDefinition_MailGroup.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._mailContents = [];
    this._hasEntry = false;
    this._entry = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._mailContents.length > 0) return false;
    if (this._hasEntry && !this._entry.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MailDefinition_MailGroup) {
      return value;
    }
    return MailDefinition_MailGroup.fromJson(value);
  }
  static fromJson(json) {
    const result = new MailDefinition_MailGroup();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    result._mailContents = JsonToList(json.mailContents, MailDefinition_MailContent);
    if (json.entry != null) {
      result._hasEntry = true;
      result._entry = dcei_wildsky_common_proto.PageNavigationEntry.fromJson(json.entry);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._mailContents.length > 0) {
      result.mailContents = ArrayToJson(this._mailContents, MailDefinition_MailContent);
    }
    if (this._hasEntry && !this._entry.isEmpty()) {
      result.entry = dcei_wildsky_common_proto.PageNavigationEntry.toJson(this._entry);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {MailDefinition_MailContent[]}
   */
  get mailContents() {
    return this._mailContents;
  }
  addMailContents(path, value) {
    return {type: 'ADD', path: path.concat(['mailContents']), value: value.toJson()};
  }
  setMailContents(path, value) {
    return {type: 'SET', path: path.concat(['mailContents']), value: ArrayToJson(value, MailDefinition_MailContent)};
  }
  setMailContentsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['mailContents', key]), value: value.toJson()};
  }
  deleteMailContents(path) {
    return {type: 'DELETE', path: path.concat(['mailContents'])};
  }
  deleteMailContentsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['mailContents', key])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.PageNavigationEntry}
   */
  get entry() {
    return this._hasEntry ? this._entry : dcei_wildsky_common_proto.PageNavigationEntry.default;
  }
  get hasEntry() {
    return this._hasEntry;
  }
  setEntry(path, value) {
    return {type: 'SET', path: path.concat(['entry']), value: value.toJson()};
  }
  deleteEntry(path) {
    return {type: 'DELETE', path: path.concat(['entry'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MailDefinition_MailGroup(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new MailDefinition_MailGroup(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "mailContents": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MailDefinition_MailGroup(this);
              copy._mailContents = [];        for (let i of value) {
                copy._mailContents.push(MailDefinition_MailContent.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MailDefinition_MailGroup(this);
              copy._mailContents = copy._mailContents.concat([MailDefinition_MailContent.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._mailContents.length === 0) {
                return this;
              }
              const copy = new MailDefinition_MailGroup(this);
              copy._mailContents = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._mailContents.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MailDefinition_MailGroup(this);
              copy._mailContents = copy._mailContents.slice();
              copy._mailContents[path[1]] = MailDefinition_MailContent.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MailDefinition_MailGroup(this);
              copy._mailContents = copy._mailContents.slice(0, path[1]).concat(copy._mailContents.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._mailContents.length) {
            return this;
          }
          const oldValue = this._mailContents[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MailDefinition_MailGroup(this);
          copy._mailContents = copy._mailContents.slice();
          copy._mailContents[key] = newValue;
          return copy;
        }
      }
      case "entry": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MailDefinition_MailGroup(this);
              copy._hasEntry = true;
              copy._entry = dcei_wildsky_common_proto.PageNavigationEntry.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEntry) {
                return this;
              }
              const copy = new MailDefinition_MailGroup(this);
              copy._hasEntry = false;
              copy._entry = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasEntry) {
            const copy = new MailDefinition_MailGroup(this);
            copy._hasEntry = true;
            copy._entry = dcei_wildsky_common_proto.PageNavigationEntry.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._entry.apply(type, path.slice(1), value);
          if (newValue === this._entry) {
            return this;
          }
          const copy = new MailDefinition_MailGroup(this);
          copy._entry = copy._entry.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MailDefinition_MailGroup} other
   * @returns {MailDefinition_MailGroup}
   */
  merge(other) {
    const copy = new MailDefinition_MailGroup(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    copy._mailContents = this._mailContents.concat(other._mailContents);
    if (other._hasEntry) {
      if (copy._hasEntry) {
        copy._entry = copy.entry.merge(other.entry);
      } else {
        copy._entry = other._entry;
      }
      copy._hasEntry = true;
    }
    return copy;
  }
}
MailDefinition_MailGroup.default = new MailDefinition_MailGroup();
class MailDefinition_MailGroup_Builder {
  constructor(value) {
    this._value = new MailDefinition_MailGroup(value);
  }
  build() {
    return new MailDefinition_MailGroup(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  addAllMailContents(values) {
    this._value._mailContents = this._value._mailContents.concat(values);
    return this;
  }
  addMailContents(value) {
    this._value._mailContents = this._value._mailContents.concat([value]);
    return this;
  }
  setMailContents(index, value) {
    this._value._mailContents = this._value._mailContents.concat();
    this._value._mailContents[index] = value;
    return this;
  }
  clearMailContents() {
    this._value._mailContents = [];
    return this;
  }
  setEntry(value) {
    this._value._hasEntry = true;
    this._value._entry = value;
    return this;
  }
  deleteEntry() {
    this._value._hasEntry = false;
    this._value._entry = null;
    return this;
  }
}
MailDefinition_MailGroup.Builder = MailDefinition_MailGroup_Builder;
class MailDefinition_MailGroup_WithParent {
  /**
   * @param {MailDefinition_MailGroup} value
   * @param {MailDefinition_MailGroup_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MailDefinition_MailGroup.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get selfMailContents() {
    if (!this._selfMailContents) {
      this._selfMailContents = [];
      for (let i of this._value.mailContents) {
        this._selfMailContents.push(new MailDefinition_MailContent.WithParent(i, null));
      }
    }
    return this._selfMailContents;
  }
  get inherentMailContents() {
    if (!this._inherentMailContents) {
      this._inherentMailContents = this._parent ? this._parent.mailContents : [];
    }
    return this._inherentMailContents;
  }
  get mailContents() {
    if (!this._allMailContents) {
      this._allMailContents = this._parent ? this._parent.mailContents.concat(this.selfMailContents) : this.selfMailContents;
    }
    return this._allMailContents;
  }
  get hasEntry() {
    if (this._cachedHasEntry === undefined) {
      if (this._value.hasEntry) {
        this._cachedHasEntry = true;
      } else {
        this._cachedHasEntry = this._parent ? this._parent.hasEntry : false;
      }
    }
    return this._cachedHasEntry;
  }
  get entry() {
    if (!this._cachedEntry) {
      if (this._value.hasEntry) {
        this._cachedEntry = new dcei_wildsky_common_proto.PageNavigationEntry.WithParent(this._value.entry, this._parent && this._parent.hasEntry ? this._parent.entry : null);
      } else {
        this._cachedEntry = this._parent ? new dcei_wildsky_common_proto.PageNavigationEntry.WithParent(dcei_wildsky_common_proto.PageNavigationEntry.default, this._parent.entry) : dcei_wildsky_common_proto.PageNavigationEntry.WithParent.default;
      }
    }
    return this._cachedEntry;
  }
  update(current, parent) {
    const result = new MailDefinition_MailGroup_WithParent(current, parent);
    if (this._selfMailContents) {
      if (this._value.mailContents === current.mailContents) {
        result._selfMailContents = this._selfMailContents;
      } else {
        result._selfMailContents = [];
        for (let i = 0; i < current.mailContents.length; i++) {
          const oldValue = this._value.mailContents[i];
          if (oldValue) {
            const oldCache = this._selfMailContents[i];
            if (oldValue === current.mailContents[i]) {
              result._selfMailContents[i] = oldCache;
            } else {
              result._selfMailContents[i] = oldCache.update(current.mailContents[i], null);
            }
          } else {
            result._selfMailContents[i] = new MailDefinition_MailContent.WithParent(current.mailContents[i], null);
          }
        }
      }
    }
    if (this._cachedEntry && this._value.hasEntry && current.hasEntry) {
      if (this._value.entry === current.entry && this._parent === parent) {
        result._cachedEntry = this._cachedEntry;
      } else {
        result._cachedEntry = this._cachedEntry.update(current.entry, parent && parent.hasEntry ? parent.entry : null);
      }
    }
    return result;
  }
}
MailDefinition_MailGroup_WithParent.default = new MailDefinition_MailGroup_WithParent(MailDefinition_MailGroup.default, null);
MailDefinition_MailGroup.WithParent = MailDefinition_MailGroup_WithParent;
class MailDefinition_MailGroup_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get mailContents() {
    if (!this._mailContents) {
      this._mailContents = {
        name: "mailContents",
        Name: "MailContents",
        number: 4,
        protoType: 11,
        protoName: "mail_contents",
        type: MailDefinition_MailContent,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mailContents;
  }
  get entry() {
    if (!this._entry) {
      this._entry = {
        name: "entry",
        Name: "Entry",
        number: 7,
        protoType: 11,
        protoName: "entry",
        type: dcei_wildsky_common_proto.PageNavigationEntry,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._entry;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.mailContents,
        this.entry,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEntry",
        Name: "DummyOneofForEntry",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
MailDefinition_MailGroup.descriptor = new MailDefinition_MailGroup_Descriptor();
export class MailDefinition {
  get descriptor() {
    return MailDefinition.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._mailGroups = [];
  }
  isEmpty() {
    if (this._mailGroups.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MailDefinition) {
      return value;
    }
    return MailDefinition.fromJson(value);
  }
  static fromJson(json) {
    const result = new MailDefinition();
    result._mailGroups = JsonToList(json.mailGroups, MailDefinition_MailGroup);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._mailGroups.length > 0) {
      result.mailGroups = ArrayToJson(this._mailGroups, MailDefinition_MailGroup);
    }
    return result;
  }
  /**
   * @returns {MailDefinition_MailGroup[]}
   */
  get mailGroups() {
    return this._mailGroups;
  }
  addMailGroups(path, value) {
    return {type: 'ADD', path: path.concat(['mailGroups']), value: value.toJson()};
  }
  setMailGroups(path, value) {
    return {type: 'SET', path: path.concat(['mailGroups']), value: ArrayToJson(value, MailDefinition_MailGroup)};
  }
  setMailGroupsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['mailGroups', key]), value: value.toJson()};
  }
  deleteMailGroups(path) {
    return {type: 'DELETE', path: path.concat(['mailGroups'])};
  }
  deleteMailGroupsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['mailGroups', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "mailGroups": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MailDefinition(this);
              copy._mailGroups = [];        for (let i of value) {
                copy._mailGroups.push(MailDefinition_MailGroup.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MailDefinition(this);
              copy._mailGroups = copy._mailGroups.concat([MailDefinition_MailGroup.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._mailGroups.length === 0) {
                return this;
              }
              const copy = new MailDefinition(this);
              copy._mailGroups = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._mailGroups.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MailDefinition(this);
              copy._mailGroups = copy._mailGroups.slice();
              copy._mailGroups[path[1]] = MailDefinition_MailGroup.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MailDefinition(this);
              copy._mailGroups = copy._mailGroups.slice(0, path[1]).concat(copy._mailGroups.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._mailGroups.length) {
            return this;
          }
          const oldValue = this._mailGroups[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MailDefinition(this);
          copy._mailGroups = copy._mailGroups.slice();
          copy._mailGroups[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MailDefinition} other
   * @returns {MailDefinition}
   */
  merge(other) {
    const copy = new MailDefinition(this);
    copy._mailGroups = this._mailGroups.concat(other._mailGroups);
    return copy;
  }
}
MailDefinition.default = new MailDefinition();
MailDefinition.MailContent = MailDefinition_MailContent;
MailDefinition.MailGroup = MailDefinition_MailGroup;
class MailDefinition_Builder {
  constructor(value) {
    this._value = new MailDefinition(value);
  }
  build() {
    return new MailDefinition(this._value);
  }
  addAllMailGroups(values) {
    this._value._mailGroups = this._value._mailGroups.concat(values);
    return this;
  }
  addMailGroups(value) {
    this._value._mailGroups = this._value._mailGroups.concat([value]);
    return this;
  }
  setMailGroups(index, value) {
    this._value._mailGroups = this._value._mailGroups.concat();
    this._value._mailGroups[index] = value;
    return this;
  }
  clearMailGroups() {
    this._value._mailGroups = [];
    return this;
  }
}
MailDefinition.Builder = MailDefinition_Builder;
class MailDefinition_WithParent {
  /**
   * @param {MailDefinition} value
   * @param {MailDefinition_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MailDefinition.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfMailGroups() {
    if (!this._selfMailGroups) {
      this._selfMailGroups = [];
      for (let i of this._value.mailGroups) {
        this._selfMailGroups.push(new MailDefinition_MailGroup.WithParent(i, null));
      }
    }
    return this._selfMailGroups;
  }
  get inherentMailGroups() {
    if (!this._inherentMailGroups) {
      this._inherentMailGroups = this._parent ? this._parent.mailGroups : [];
    }
    return this._inherentMailGroups;
  }
  get mailGroups() {
    if (!this._allMailGroups) {
      this._allMailGroups = this._parent ? this._parent.mailGroups.concat(this.selfMailGroups) : this.selfMailGroups;
    }
    return this._allMailGroups;
  }
  update(current, parent) {
    const result = new MailDefinition_WithParent(current, parent);
    if (this._selfMailGroups) {
      if (this._value.mailGroups === current.mailGroups) {
        result._selfMailGroups = this._selfMailGroups;
      } else {
        result._selfMailGroups = [];
        for (let i = 0; i < current.mailGroups.length; i++) {
          const oldValue = this._value.mailGroups[i];
          if (oldValue) {
            const oldCache = this._selfMailGroups[i];
            if (oldValue === current.mailGroups[i]) {
              result._selfMailGroups[i] = oldCache;
            } else {
              result._selfMailGroups[i] = oldCache.update(current.mailGroups[i], null);
            }
          } else {
            result._selfMailGroups[i] = new MailDefinition_MailGroup.WithParent(current.mailGroups[i], null);
          }
        }
      }
    }
    return result;
  }
}
MailDefinition_WithParent.default = new MailDefinition_WithParent(MailDefinition.default, null);
MailDefinition.WithParent = MailDefinition_WithParent;
class MailDefinition_Descriptor {
  get mailGroups() {
    if (!this._mailGroups) {
      this._mailGroups = {
        name: "mailGroups",
        Name: "MailGroups",
        number: 1,
        protoType: 11,
        protoName: "mail_groups",
        type: MailDefinition_MailGroup,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mailGroups;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.mailGroups,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
MailDefinition.descriptor = new MailDefinition_Descriptor();
